<div class="flex flex-col gap-6">

  <div class="flex flex-wrap items-center justify-between gap-2">
    <elcia-title [iconType]="'dashboard'" [title]="'app.dashboard' | translate"/>

    <div class="flex flex-col items-end">
      <span class="text-lg font-semibold">{{ 'dashboard.greeting' | translate: greetingParams() }}</span>
      <span class="text-xs text-[var(--p-surface-500)]">{{ referenceMonth | date: 'MMMM yyyy' }}</span>
    </div>
  </div>

  <!-- Chaque section correspond à un domaine et à sa permission : sans le droit, elle disparaît en
       entier plutôt que de laisser un titre au-dessus du vide. -->
  @if (currentUserService.hasTodoAccess()) {
    <section class="flex flex-col gap-3">
      <h2 class="text-xs font-semibold tracking-wide text-[var(--p-surface-500)] uppercase">
        {{ 'dashboard.section.todos' | translate }}
      </h2>
      <elcia-dashboard-urgent-todos/>
    </section>
  }

  @if (currentUserService.hasTimesheetAccess()) {
    <section class="flex flex-col gap-3">
      <h2 class="text-xs font-semibold tracking-wide text-[var(--p-surface-500)] uppercase">
        {{ 'dashboard.section.timesheets' | translate }}
      </h2>
      <!-- Trois cartes sur une rangée en 5 colonnes : les deux graphes en prennent deux chacun, la
           tuile la dernière. Hauteur fixée pour qu'elles s'alignent sans laisser de creux. -->
      <div class="grid grid-cols-1 items-stretch gap-4 sm:grid-cols-2 xl:h-72 xl:grid-cols-5">
        <elcia-dashboard-time-chart class="h-full xl:col-span-2"/>
        <elcia-dashboard-time-breakdown class="h-full xl:col-span-2"/>
        <elcia-dashboard-time-tile class="h-full"/>
      </div>
    </section>
  }

  @if (currentUserService.hasFinanceAccess()) {
    <section class="flex flex-col gap-3">
      <h2 class="text-xs font-semibold tracking-wide text-[var(--p-surface-500)] uppercase">
        {{ 'dashboard.section.finance' | translate }}
      </h2>
      <!-- items-stretch plutôt qu'items-start : les deux cartes doivent finir à la même hauteur. -->
      <!-- Hauteur fixée sur la rangée : les deux cartes ont un contenu extensible, sans repère elles
           n'auraient plus de hauteur propre. Au-dessous de xl elles s'empilent et reprennent la leur. -->
      <div class="grid grid-cols-1 items-stretch gap-4 xl:h-[30rem] xl:grid-cols-3">
        <elcia-dashboard-invoicing-chart class="h-full"/>
        <elcia-dashboard-product-history class="h-full xl:col-span-2"/>
      </div>
    </section>
  }
</div>
